import { ArrowDownWideNarrow, Clock, Star } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./motion/select";

export function DiscoverySort({ value, onChange, showRating, showPrice, id, className = "" }: {
  value: string;
  onChange: (value: string) => void;
  showRating: boolean;
  showPrice: boolean;
  id?: string;
  className?: string;
}) {
  const { t } = useI18n();
  const options = [
    { value: "newest", label: t("discovery.sort.newest"), Icon: Clock },
    ...(showRating ? [{ value: "rating", label: t("discovery.sort.rated"), Icon: Star }] : []),
    ...(showPrice ? [{ value: "price", label: t("discovery.sort.price"), Icon: ArrowDownWideNarrow }] : []),
  ];
  const selected = options.find((option) => option.value === value) ?? options[0];
  return <Select id={id} value={selected.value} onValueChange={onChange} className={className}>
    <SelectTrigger aria-label={t("discovery.sortBy") + ": " + selected.label} className="h-full text-inherit">
      <selected.Icon aria-hidden="true" className="h-4 w-4 shrink-0" />
      <span className="min-w-0 flex-1 truncate text-left">{selected.label}</span>
    </SelectTrigger>
    <SelectContent className="z-50 min-w-full w-max max-w-[calc(100vw-32px)] bg-white">
      {options.map(({ value: optionValue, label, Icon }) => <SelectItem key={optionValue} value={optionValue} textValue={label}>
        <span className="flex items-center gap-3 whitespace-nowrap"><Icon aria-hidden="true" className="h-4 w-4 shrink-0" />{label}</span>
      </SelectItem>)}
    </SelectContent>
  </Select>;
}
